import { render, staticRenderFns } from "./welcome_page.vue?vue&type=template&id=7acc8189&scoped=true&"
import script from "./welcome_page.vue?vue&type=script&lang=js&"
export * from "./welcome_page.vue?vue&type=script&lang=js&"
import style0 from "./welcome_page.vue?vue&type=style&index=0&id=7acc8189&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acc8189",
  null
  
)

export default component.exports